/** Modes */
const URL_BACK = process.env.NODE_ENV === 'development' ? 'https://intermeetingonline.com.mx/apiAWS' : 'https://api.imsvirtualcenter.com.mx'
console.log(process.env.NODE_ENV)
const IS_QA = true
let ADMIN_SITE
if (IS_QA) {
  ADMIN_SITE = 'https://admin.imsvirtualcenter.com.mx/'
} else {
  ADMIN_SITE = 'http://localhost:8081/'
}
const URLBUCKETFILE = 'https://s3.us-east-2.amazonaws.com/files.digicongress.com.mx/'
export {
  ADMIN_SITE,
  URL_BACK,
  URLBUCKETFILE
}



//////////////////
// WEBPACK FOOTER
// ./viariableProd.js
// module id = vFsp
// module chunks = 13